$(document).on('click','.active_currency',function(e){
  e.preventDefault();
  $('.currency_picker').slideToggle();
  $('li.currency_list').toggleClass('active')
});

$(document).on('click','.mob-arw-link',function(e){
  e.preventDefault();
  $(this).next('.mob-second-level').addClass('active');
});
$(document).on('click','.back-arrow',function(e){
  e.preventDefault();
  $(this).closest('.mob-second-level').removeClass('active');
});
$(document).on('click','.menu-burger,.menu-drawer-close',function (e) {
  e.preventDefault();
  $('body').toggleClass('menu-open');
  $('.search-open').removeClass('search-open');
});
$(document).on('click','.menu-drawer-close',function (e) {
  e.preventDefault();
  $('body').removeClass('menu-open');
  $('.mob-second-level').removeClass('active');
});
$(document).on('click','.header_weglot_btn',function(e){
  e.preventDefault();
  $(this).closest('.header_weglotcls').toggleClass('active');
});

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');

    this.input.addEventListener(
        'input',
        this.debounce((event) => {
          const input_length = this.input.value.length;
          const recommendedDiv = document.querySelector('.search_recommended');
          document.querySelectorAll('.search-Button').forEach(function (btn) {
            btn.disabled = input_length === 0;
          });
          if (input_length === 0) {
            this.close();
            if (recommendedDiv) {
              recommendedDiv.style.display = 'flex';

              if (window.innerWidth < 992 && $('.searchmobileslider').length) {
                if ($('.searchmobileslider').data('flickity')) {
                  $('.searchmobileslider').flickity('destroy');
                }
                $('.searchmobileslider').flickity({
                  autoPlay: false,
                  cellAlign: 'left',
                  groupCells: 2,
                });
              }
            }
            return; 
          }
          this.onChange(event);
        }, 300).bind(this)
      );
  }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }
      this.getSearchResults(searchTerm);
    }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=8&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const resultsContainer = doc.querySelector('#predictive-search-results');
        const resultsMarkup = resultsContainer
          ? resultsContainer.innerHTML
          : '';

        this.predictiveSearchResults.innerHTML = resultsMarkup;

        const recommendedDiv = document.querySelector('.search_recommended');
        const recommendedwrap = document.querySelector('.search_recommended_wrap');
        const hasProducts = doc.querySelector('.search-row .search-column');
        const itemtitle = document.querySelector('.search-reasult-items-wrap .g-label');
        
        
          if (recommendedDiv) {
            if (hasProducts) {
              recommendedDiv.style.display = 'none';
              recommendedwrap.style.display = 'flex';
              itemtitle.style.display = 'block';
              recommendedDiv.classList.remove('recom-min-height');
            } else {
              recommendedDiv.style.display = 'flex';
              recommendedwrap.style.display = 'none';
              itemtitle.style.display = 'none';
              recommendedDiv.classList.add('recom-min-height');
            }
          }

        this.open();

        if (document.getElementById('SearchValue')) {
          document.getElementById('SearchValue').value = searchTerm;
        }
         if (window.innerWidth >= 991 && $('.searchslider').length) {
              $('.searchslider').flickity('destroy');
              $('.searchslider').flickity({
                autoPlay: false,
                cellAlign: 'left',
                groupCells: 1, 
              });
          }
        // setTimeout(function() {
          if (window.innerWidth < 992 && $('.searchmobileslider').length) {
            if ($('.searchmobileslider').data('flickity')) {
              $('.searchmobileslider').flickity('destroy');
            }
            $('.searchmobileslider').flickity({
              autoPlay: false,
              cellAlign: 'left',
              groupCells: 2,
            });
          }
        // }, 200);
      })
      .catch((error) => {
        this.close();
        const recommendedDiv = document.querySelector('.search_recommended');
        if (recommendedDiv) {
          recommendedDiv.style.display = 'flex';
        }

        console.error(error);
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    $('.searchcls').addClass('searchdata');
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    $('.searchcls').removeClass('searchdata');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

function openSearch() {
  var searchcls = document.querySelector('.searchcls');
  $('body').addClass('search-open');
  $('body').removeClass('menu-open');
  $('#Search').focus();
  if (searchcls) {
    searchcls.classList.remove('animated');
    // Double rAF: lets browser paint the element at start state (top:-15px)
    // first, then adds .animated to trigger the smooth top transition
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        searchcls.classList.add('animated');
      });
    });
  }
}

function closeSearch() {
  var searchcls = document.querySelector('.searchcls');
  $('body').removeClass('search-open');
  if (searchcls) searchcls.classList.remove('animated');
}

$(document).on('click', '.search-btn,.mob-search-btn,.search-close', function(e) {
  e.preventDefault();
  if ($('body').hasClass('search-open')) {
    closeSearch();
  } else {
    openSearch();
  }

  if (window.innerWidth < 992 && $('.searchmobileslider').length) {
    setTimeout(function() {
      if ($('.searchmobileslider').data('flickity')) {
        $('.searchmobileslider').flickity('destroy');
      }
      $('.searchmobileslider').flickity({
        autoPlay: false,
        cellAlign: 'left',
        groupCells: 2,
      });
    }, 200);
  }
});

$(document).on('click', '.overlay-box', function(e) {
  e.preventDefault();
  closeSearch();
});

jQuery(document).on('keyup', function(evt) {
  if (evt.keyCode == 27) {
    closeSearch();
  }
});
$('.mega-list').hover(function() {
   $('body').addClass('hover-nav');
}, function() {
   $('body').removeClass('hover-nav');
});
// const notificationbar = document.querySelector('.announcment-bar-outer-container');
// document.addEventListener('scroll', ()=>{
//   if(window.scrollY >= 537){
//     notificationbar.classList.add('announcement-bar-hide')
//   } else if(window.scrollY < 537){
//     notificationbar.classList.remove('announcement-bar-hide')

//   }
// })
$(window).on('scroll',function(e){
  const notificationbar = document.querySelector('.announcment-bar-outer-container')
  var scroll = $(window).scrollTop();
  var header_height = $('.header-group').height() + 100;
  // var window_height = (($(window).height()) - ($(window).height()/4));
  var window_height = (250);
  if(scroll >= window_height){
    $('body').addClass('default-header');
    if(notificationbar != null){
      notificationbar.classList.add('announcement-bar-hide');
  } 
  }else{
    $('body').removeClass('default-header');
    if(notificationbar != null){
      notificationbar.classList.remove('announcement-bar-hide');
    }
  }
});

let wishlist_count = localStorage.getItem('th_wlc_pro_count');
if(wishlist_count > 0){
  let headerIcon = $('.header-right .th_wlc_position_relative');
  headerIcon.each(function() {
    $(this).addClass('active');
  });
}

function updateSearchTop() {
    const searchDiv = document.querySelector('.searchcls');
    if (!searchDiv) return;
    if (window.innerWidth >= 992) { 
        const announcementBar = document.querySelector('.announcment-bar-outer-container');
        const sectionHeader = document.querySelector('.section-header');

        const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const sectionHeight = sectionHeader ? sectionHeader.offsetHeight : 0;
        const totalHeight = announcementHeight + sectionHeight;

        searchDiv.style.top = totalHeight + 'px';
    }
}
window.addEventListener('load', updateSearchTop);
window.addEventListener('resize', updateSearchTop);
